import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  agendaButton: {
    width: "120px",
    height: "55px",
    borderRight: `1px solid ${theme.palette.border.default}`,
    padding: "10px",
    textDecoration: "none",
    borderRadius: 0,
    color: theme.palette.events.textPrimary,
    "&:hover": {
      color: theme.palette.events.textPrimary,
      textDecoration: "none",
    },
  },
}));
